import { render } from "./index.vue?vue&type=template&id=d5994102&scoped=true?status=200"
import script from "./index.vue?vue&type=script&lang=js?status=200"
export * from "./index.vue?vue&type=script&lang=js?status=200"

import "./index.vue?vue&type=style&index=0&id=d5994102&lang=less&scoped=true?status=200"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5994102"]])

export default __exports__